import { Component } from '@angular/core';

import { AuthService } from '../../shared/services/auth.service';

import { STATIC_VALUE } from '../../shared/configuration/static.value';

import { ErrorService } from '../../shared/services/error.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { LayoutService } from '../../shared/services/layout.service';

@Component({
    selector: 'change-password',
    templateUrl: 'change-password.component.html'
})

export class LoginChangePasswordComponent{

    vEmail: string;

    constructor(
        private _authService: AuthService,
        private _layoutService: LayoutService, 
        private _pageNavigationService: PageNavigationService,
        private _errorService: ErrorService
    ) {
        
    }

    ngOnInit() {
    	this._layoutService.setCurrentPage('login-change-password');
        this._authService.resetError();
        this._authService.resetForceChangePassData();
    }

    getErrorStatusAndMessage(){
        return this._errorService.getErrorStatusAndMessage();
    }

    getBackEndError(){
        return this._errorService.getBackEndError();
    }

    getSecurityQuestionList(){
        return STATIC_VALUE.SECURITY_QUESTION_LIST;
    }

    getChangePasswordData(){
        return this._authService.vForceChangePassData;
    }

    isDisableSubmit(){
        return this._authService.isDisableChangePasswordInput();
    }

    isLoading(){
        return this._authService.getLoadingStatus();
    }

    changePassword(){
        this._authService.changePassword();
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/login/components/change-password.component.ts